import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-no-matched-shared-route',
	templateUrl: './no-matched-shared-route.component.html',
	styleUrls: ['./no-matched-shared-route.component.scss'],
	imports: [IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoMatchedSharedRouteComponent {}
